<script setup>
import { ref, reactive, onMounted, computed, watch, toRaw } from 'vue'
import axios from 'axios'
import gwcdLogoRaw from '@/assets/gwcd.png'

const TYP_CHOICES = { gwcd: 'GWCD Mitglied', nongwcd: 'Kein GWCD Mitglied' }
const TYP_OPTION = { 
  F0: 'Verlängerung ohne Frühstück', 
  F1: 'Verlängerung mit Frühstück', 
  F2: 'Verlängerung mit Halbpension',
  F3: 'Verlängerung mit Vollpension',
  B1: 'Buffet Pauschal einmalig',
  B2: 'Buffet Pauschal pro Nacht',
  P1: 'Person Pauschal',
  P2: 'Kurtaxe Pauschal pro Tag',
  N: 'keine Option' 
}
const TYP_ABRECHNUNG = { 
  G: 'GWCD', 
  H: 'HOTEL',
  V: 'VORORT'
}

const TYP_PAUSCHAL = {
    N: '---',
    B: 'Pauschalartikel Buffet',
    P: 'Pauschalartikel Person',
}

const FRONTEND_SECRET = 'NONebLR0dkl01rNA6aCcPtLJJ3z7uiBxVsXQVPDXtjcVQAFISdWN9DtsYPVqpunKs7LlJ10rPs9QH12l'

const gwcdLogo = import.meta.env.MODE === 'development'
  ? gwcdLogoRaw
  : '/gwcd2' + gwcdLogoRaw

const API_BASE = import.meta.env.MODE === 'development'
  ? '/api'             // oder dein Dev-Backend
  : '/gwcd2/api';       // oder dein Prod-Pfad (z.B. mit Subfolder)

const dateRegex = /^([0-2]\d|3[01])\.(0\d|1[0-2])\.(\d{4})$/

const personalie = reactive({
  gwcdmitglied: 'gwcd', // <-- Vorauswahl
  mitgliedsnummer: '',
  vorname: '',
  nachname: '',
  geburtsdatum: '', // <--- hinzufügen
  strasse: '',
  plz: '',
  wohnort: '',
  geburtsdatum: '', // <--- hinzufügen
  telefon: '',
  email: '',
  bemerkung: '',
  uebernachtung: '',
  anreisetag: '',
  abreisetag: ''
})

const mitreisende = ref([
  { 
    vorname: '', 
    nachname: '', 
    mitgliedsnummer: '',
    geburtsdatum: ''
}
])

const bestellung = ref([
  { artikel: '', anzahl: 1, option: 'N', option_anzahl: 0, option_text: '', buffet: 'N', buffet_anzahl: 0, buffet_text: '' }
])

const aktTreffen = ref([])
const rechtstexte = ref([])
const alleRechtstexte = ref([])
const alleInfotexte = ref([]) 
const alleArtikelGruppen = ref([])
const pauschalArtikelGruppe = ref([])
const tshirtArtikelGruppe = ref([])
const uebernachtungArtikelGruppen = ref([]) 
const ausgewaehlteArtikelgruppe = ref('')
const treffen = ref(window.TREFFEN_ID || '') // nur die ID
const anmeldung_geschlossen = ref(window.ANMELDUNG_GESCHLOSSEN || false);
const info_message = ref(window.INFO_MESSAGE || '');

// Lädt Rechtstexte und Artikel für das gewählte Treffen
async function loadTreffenAbhaengigeDaten() {
  if (!treffen.value) {
    alleRechtstexte.value = []
    alleArtikelGruppen.value = []
    pauschalArtikelGruppe.value = []
    tshirtArtikelGruppe.value = []
    uebernachtungArtikelGruppen.value = []
    alleInfotexte.value = []
    return
  }

  // Rechtstexte laden
  const rechtstexteRes = await axios.get(
    `${API_BASE}/rechtstexte/`,
    {
      params: { treffen: treffen.value },
      headers: { 'X-Frontend-Secret': FRONTEND_SECRET }
    }
  )
  alleRechtstexte.value = rechtstexteRes.data

  // Infotexte laden
  const infoRes = await axios.get(
    `${API_BASE}/infotexte/`,
    {
      params: { treffen: treffen.value },
      headers: { 'X-Frontend-Secret': FRONTEND_SECRET }
    }
  )
  alleInfotexte.value = infoRes.data

  // Artikel laden
  const artikelRes = await axios.get(`${API_BASE}/artikel/`, 
  { 
    params: { treffen: treffen.value },
    headers: { 'X-Frontend-Secret': FRONTEND_SECRET }
  })
  alleArtikelGruppen.value = artikelRes.data

  // Filter für Übernachtungs-Gruppen mit den artikel welche "pro Nacht" im Detail haben
  uebernachtungArtikelGruppen.value = artikelRes.data
  .map(g => ({
    ...g,
    artikel: g.artikel.filter(a =>
      a.artikeldetail &&
      a.artikeldetail.toLowerCase().includes('pro nacht')  
    )
  }))
  .filter(g => g.artikel.length > 0)
  console.log('Übernachtungs-Gruppen:', uebernachtungArtikelGruppen.value)

  // Filter für Pauschalartikel-Gruppe
  pauschalArtikelGruppe.value = artikelRes.data.find(g => g.gruppe === 'Pauschal') 

  // Filter für T-Shirts-Gruppe
  tshirtArtikelGruppe.value = artikelRes.data.filter(g => g.gruppe === 'T-Shirts')
}

// Treffen laden beim Mount
onMounted(async () => {
  const treffenRes = await axios.get(`${API_BASE}/treffen/`, 
    {
      params: { treffen: routeTreffenUuid.value },
      headers: { 'X-Frontend-Secret': FRONTEND_SECRET } 
    }
  );
  aktTreffen.value = treffenRes.data;
  treffen.value = aktTreffen.value.length ? aktTreffen.value[0].id : '';
  console.log('Aktuelles Treffen:', treffen.value);
})

// Beobachte die Auswahl von Treffen
watch(treffen, loadTreffenAbhaengigeDaten)

const bestellSumme = computed(() => {
  summe = bestellung.value.reduce((sum, b) => {
    const artikel = alleArtikel.value.find(a => a.id === b.artikel)
    const preis = artikel ? parseFloat(artikel.preis) : 0
    const optionPreis = b.option && b.option.option_preis ? parseFloat(b.option.option_preis) : 0
    if (istPauschalArtikel(b.artikel)) {
      return sum + (b.anzahl || 1) * optionPreis * (b.option_anzahl || 0)
    }
    return sum + (preis * (b.anzahl || 1)) + (optionPreis * (b.option_anzahl || 0)) + ((b.buffet_preis || 0) * (b.buffet_anzahl || 0))
  }, 0)
  return summe
})

const neuerMitreisender = reactive({
  vorname: '',
  nachname: '',
  mitgliedsnummer: '',
  geburtsdatum: ''
})

function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}
const csrftoken = getCookie('csrftoken');

function addMitreisender() {
  // Prüfe, ob eines der Felder ausgefüllt ist
  if (
    neuerMitreisender.vorname ||
    neuerMitreisender.nachname ||
    neuerMitreisender.geburtsdatum
  ) {
    // Prüfe, ob alle Felder ausgefüllt sind
    if (
      !neuerMitreisender.vorname ||
      !neuerMitreisender.nachname ||
      !neuerMitreisender.geburtsdatum
    ) {
      alert('Bitte füllen Sie Vorname, Nachname und Geburtsdatum für Mitreisende aus.');
      return;
    }
    mitreisende.value.push({ ...neuerMitreisender });
    neuerMitreisender.vorname = '';
    neuerMitreisender.nachname = '';
    neuerMitreisender.mitgliedsnummer = '';
    neuerMitreisender.geburtsdatum = '';
  }
}

function removeMitreisender(idx) {
  mitreisende.value.splice(idx, 1)
}

function addBestellung() {
  bestellung.value.push({ artikel: '', anzahl: 1, option: null, option_anzahl: 0, option_text: '', buffet: 'N', buffet_anzahl: 0, buffet_text: '' })
  console.log('Bestellung hinzugefügt:', bestellung.value);
}

function removeBestellung(idx) {
  bestellung.value.splice(idx, 1)
}

const alleArtikel = computed(() =>
  alleArtikelGruppen.value.flatMap(g => g.artikel)
)
const buchungZusammenfassung = ref(null)
const buchungHtml = ref('')
const isSubmitting = ref(false)

async function handleSubmit() {
  
  isSubmitting.value = true
  const payload = {
    treffen:  treffen.value, 
    personalie: { ...personalie },
    mitreisende: mitreisende.value,
    bestellung: bestellung.value.map((b, idx) => {
      const artikel = alleArtikel.value.find(a => a.id === b.artikel)
      const option_array = []

      // Option hinzufügen, falls vorhanden
      if (b.option && b.option !== 'N') {
        option_array.push({
          type: 'option',
          value: b.option.option ?? b.option,
          text: b.option.option_text ?? '',
          preis: b.option.option_preis ?? 0,
          anzahl: b.option_anzahl ?? 0
        })
      }

      // Buffet hinzufügen, falls vorhanden
      if (b.buffet && b.buffet !== 'N') {
        option_array.push({
          type: 'buffet',
          value: b.buffet,
          text: b.buffet_text ?? '',
          preis: b.buffet_preis ?? 0,
          anzahl: b.buffet_anzahl ?? 0
        })
      }
      const istUebernachtung = istUebernachtungsArtikel(b.artikel)
      return {
        artikelId: artikel ? artikel.id : null,
        istUebernachtung: istUebernachtung,
        anzahl: b.anzahl,
        preis: artikel ? parseFloat(artikel.preis) : 0,
        option_array,
      }
    }),
    rechtstexte: rechtstexte.value
  }
  try {
    const response = await axios.post(`${API_BASE}/anmeldung/`, 
    payload,
    {
      headers: { 
        'Content-Type': 'application/json',
        'X-CSRFToken': getCookie('csrftoken'),
        'X-Frontend-Secret': FRONTEND_SECRET 
      }
    })
    
    // HTML aus der Anmeldung-Response verwenden
    if (response.data.html) {
      buchungHtml.value = response.data.html
    }

    // Zusammenfassung erzeugen
    buchungZusammenfassung.value = {
      treffen: aktTreffen.value.find(t => t.id === treffen.value),
      personalie: { ...personalie },
      mitreisende: mitreisende.value.filter(m => m.vorname || m.nachname || m.mitgliedsnummer || m.geburtsdatum),
      bestellung: bestellung.value.map(b => {
        const artikel = alleArtikel.value.find(a => a.id === b.artikel)
        const option_array = []

        // Option hinzufügen, falls vorhanden
        if (b.option && b.option !== 'N') {
          option_array.push({
            type: 'option',
            value: b.option.option ?? b.option,
            text: b.option.option_text ?? '',
            preis: b.option.option_preis ?? 0,
            anzahl: b.option_anzahl ?? 0
          })
        }

        // Buffet hinzufügen, falls vorhanden
        if (b.buffet && b.buffet !== 'N') {
          option_array.push({
            type: 'buffet',
            value: b.buffet,
            text: b.buffet_text ?? '',
            preis: b.buffet_preis ?? 0,
            anzahl: b.buffet_anzahl ?? 0
          })
        }

        return {
          artikelId: artikel ? artikel.id : null,
          artikelname: artikel ? artikel.artikelname : '',
          artikeldetail: artikel ? artikel.artikeldetail : '',
          anzahl: b.anzahl,
          preis: artikel ? parseFloat(artikel.preis) : 0,
          option_array,
          gesamt: bestellSumme
        }
      }),
      rechtstexte: alleRechtstexte.value.filter(rt => rechtstexte.value.includes(rt.id))
    }
    // Formular zurücksetzen (optional)
  } catch (e) {
    let msg = 'Fehler bei der Anmeldung.\n'
    if (e.response && e.response.data) {
      if (e.response.data.error) {
        msg += e.response.data.error
      }
      if (e.response.data.exception_value) {
        msg += '\n' + e.response.data.exception_value
      }
      // Erweiterte Ausgabe
      if (e.response.status) {
        msg += `\nStatus: ${e.response.status}`
      }
      if (e.response.statusText) {
        msg += `\nStatusText: ${e.response.statusText}`
      }
      if (typeof e.response.data === 'string') {
        msg += `\nResponse: ${e.response.data}`
      } else if (typeof e.response.data === 'object') {
        msg += `\nResponse: ${JSON.stringify(e.response.data)}`
      }
    } else if (e.message) {
      msg += '\n' + e.message
    }
    alert(msg)
  } finally {
    isSubmitting.value = false
  }
}

function resetForm() {
  personalie.gwcdmitglied = 'gwcd'
  personalie.mitgliedsnummer = ''
  personalie.vorname = ''
  personalie.nachname = ''
  personalie.geburtsdatum = ''
  personalie.strasse = ''
  personalie.plz = ''
  personalie.wohnort = ''
  personalie.telefon = ''
  personalie.email = ''
  personalie.bemerkung = ''
  personalie.anreisetag = ''
  personalie.abreisetag = ''
  mitreisende.value = [{ vorname: '', nachname: '', mitgliedsnummer: '', geburtsdatum: '' }]
  neuerMitreisender.vorname = ''
  neuerMitreisender.nachname = ''
  neuerMitreisender.mitgliedsnummer = ''
  neuerMitreisender.geburtsdatum = ''
  bestellung.value = [{ artikel: '', anzahl: 1, option: null, option_anzahl: 0, buffet: null, buffet_anzahl: 0 }]
  rechtstexte.value = []
  treffen.value = ''
}

const alleRechtstexteBestaetigt = computed(() => 
  alleRechtstexte.value.length > 0 &&
  rechtstexte.value.length === alleRechtstexte.value.length
)

const routeTreffenId = computed(() => {
  const match = window.location.pathname.match(/treffen\/(\d+)/);
  return match ? match[1] : null;
});
const routeTreffenUuid = computed(() => {
  const match = window.location.pathname.match(/treffen\/([0-9a-fA-F-]+)/);
  return match ? match[1] : null;
});

function formatDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return dateStr; // default ist de-DE Format
  // if (isNaN(d)) return dateStr;
  // return d.toLocaleDateString('de-DE', {
  //   year: 'numeric',
  //   month: '2-digit',
  //   day: '2-digit'
  // });
}

function formatDate2(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d)) return dateStr;
    return d.toLocaleDateString('de-DE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
  });
}

const gefilterteArtikel = ref([])

const aktuellesTreffen = computed(() =>
  aktTreffen.value.find(t => t.id === treffen.value)
)

function onArtikelgruppeSelected() {
  if (!ausgewaehlteArtikelgruppe.value) {
    // console.log('Keine Artikelgruppe ausgewählt!');
    return;
  }
  // Hier deine Logik, wenn eine Gruppe gewählt wurde
  // console.log('Gewählte Artikelgruppe:', ausgewaehlteArtikelgruppe.value);
  const gruppe = alleArtikelGruppen.value.find(g => g.gruppe === ausgewaehlteArtikelgruppe.value)
  const uebernachtungsArtikel = gruppe ? gruppe.artikel : []
  // T-Shirt-Artikel ergänzen
  const tshirtArtikel = tshirtArtikelGruppe.value.length ? tshirtArtikelGruppe.value[0].artikel : []
  // Pauschal-Artikel ergänzen
  const pauschalArtikel = findePauschalArtikel()
  gefilterteArtikel.value = uebernachtungsArtikel.concat(tshirtArtikel, pauschalArtikel ? [pauschalArtikel] : [])
}

function parseGermanDate(str) {
  if (!str) return null;
  // Prüfe auf deutsches Format
  if (/^\d{2}\.\d{2}\.\d{4}$/.test(str)) {
    const [tag, monat, jahr] = str.split('.');
    return new Date(`${jahr}-${monat}-${tag}`);
  }
  // Prüfe auf ISO-Format
  if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
    return new Date(str);
  }
  return null;
}

function istUebernachtungsArtikel(artikelId) {
  const gruppenartikel = getArtikelGruppenById(artikelId)
  const uebernachtungsartikel = findeUebernachtungsArtikelById(artikelId)
  return !!(
    uebernachtungsartikel &&
    gruppenartikel.some(g => ['Hotel', 'Camping'].includes(g))
  )
}

function istTShirtArtikel(artikelId) {
  const gruppenartikel = getArtikelGruppenById(artikelId)
  const tshirtArtikel = findeTShirtArtikelById(artikelId)
  return !!(
    tshirtArtikel &&
    gruppenartikel.some(g => ['T-Shirts', 'T-Shirt'].includes(g))
  )
}

function istPauschalArtikel(artikelId) {
  const gruppenartikel = getArtikelGruppenById(artikelId)
  const pauschalArtikel = findePauschalArtikelById(artikelId)
  return !!(
    pauschalArtikel &&
    gruppenartikel.some(g => ['Pauschal'].includes(g))
  )
}

function bestellText(b) {
  if (b.artikel) {
    const artikel = alleArtikel.find(a => a.id === b.artikel)
    if (artikel) {
      const gruppenartikel = getArtikelGruppenById(b.artikel)
      const istUebernachtung = istUebernachtungsArtikel(b.artikel)
      console.log(`Bestell Artikel: ${b.artikel}, ArtikelGruppen: ${gruppenartikel.join(', ')}, Ist Übernachtung: ${istUebernachtung}`)
      if (istUebernachtung) {
        result = `Anzahl: 1, ${b.anzahl} Nächte, `
        if (b.option_anzahl && aktuellesTreffen.value && aktuellesTreffen.value.verl_zimmer) {
          result += `+ ${b.option_anzahl} Nächte Verlängerung, ${b.option_text} ${b.option_preis} €  `
        }
        if (b.buffet_anzahl && b.buffet_text) {
          result += `+ ${b.buffet_text} ${b.buffet_preis} € `
        } 
        return result
      } else {
        return `Anzahl: ${b.anzahl}, `
      }
    }
  } 
}

// Beobachtet die Auswahl der Artikelgruppe und setzt die Anreise- und Abreisedaten
const prevGruppe = ref(null)

watch(ausgewaehlteArtikelgruppe, (gruppe) => {
  if (gruppe && aktuellesTreffen.value) {
    personalie.anreisetag = aktuellesTreffen.value.zeitraum_von || ''
    personalie.abreisetag = aktuellesTreffen.value.zeitraum_bis || ''
  }
  // Bestellung leeren, wenn die Gruppe gewechselt wurde
  if (prevGruppe && gruppe !== prevGruppe) {
    bestellung.value = [{ artikel: '', anzahl: 1, option: null , option_anzahl: 0, buffet: null, buffet_anzahl: 0 }]
  }
  prevGruppe.value = gruppe;
  onArtikelgruppeSelected();
})

function getArtikelGruppenById(artikelId) {
  const gruppen = []
  for (const gruppe of alleArtikelGruppen.value) {
    const artikel = gruppe.artikel.find(a => a.id === artikelId)
    if (artikel) {
      if (artikel.artikelgruppen && Array.isArray(artikel.artikelgruppen)) {
        artikel.artikelgruppen.forEach(g => {
          if (!gruppen.includes(g.gruppe)) gruppen.push(g.gruppe)
        })
      } else if (!gruppen.includes(gruppe.gruppe)) {
        gruppen.push(gruppe.gruppe)
      }
    }
  }
  return gruppen
}

// Hilfsfunktion: Finde Pauschal-Artikel
function findePauschalArtikel() {
  return alleArtikel.value.find(a => a.pauschal !== 'N')
}

// Watch auf ersten Artikel in der Bestellung
watch(
  () => bestellung.value[0]?.artikel,
  (artikelId) => {
    // Prüfe, ob neuerMitreisender ausgefüllt ist und füge ihn ggf. hinzu
    if (
      neuerMitreisender.vorname ||
      neuerMitreisender.nachname ||
      neuerMitreisender.mitgliedsnummer ||
      neuerMitreisender.geburtsdatum
    ) {
      addMitreisender();
    }
    const pauschalArtikel = findePauschalArtikel()
    console.log('Pauschal-Artikel:', pauschalArtikel)
    // Wenn kein Pauschal-Artikel vorhanden ist, abbrechen
    if (artikelId && 
        pauschalArtikel &&
        aktuellesTreffen.value &&
        (aktuellesTreffen.value.buffet_pauschal === true || aktuellesTreffen.value.person_pauschal === true) && 
        ausgewaehlteArtikelgruppe.value !== 'Tagesgast'
      ) {        
      // Prüfe, ob Pauschal-Artikel schon in der Bestellung ist
      const schonDrin = bestellung.value.some(b => b.artikel === pauschalArtikel.id)
      if (!schonDrin) {
        const KurtaxePauschal = pauschalArtikel.optionen.find(o => o.option === 'P2')
        // Berechne die Anzahl der Personen (Hauptperson + ausgefüllte Mitreisende)
        const anzahlPersonen = 1 + mitreisende.value.filter(m => m.vorname || m.nachname).length
        const von = parseGermanDate(personalie.anreisetag)
        const bis = parseGermanDate(personalie.abreisetag)
        const event_von = parseGermanDate(aktuellesTreffen.value.zeitraum_von)
        const event_bis = parseGermanDate(aktuellesTreffen.value.zeitraum_bis)

        if (von && bis && !isNaN(von) && !isNaN(bis)) {
          const diff = Math.max(1, Math.ceil((bis - von) / (1000 * 60 * 60 * 24)))        

          bestellung.value.unshift({
            artikel: pauschalArtikel.id,
            anzahl: anzahlPersonen,
            option: KurtaxePauschal ? toRaw(KurtaxePauschal) : null,
            option_anzahl: KurtaxePauschal ? diff : 0,
            option_text: KurtaxePauschal ? KurtaxePauschal.option_text : '',
            option_preis: KurtaxePauschal ? KurtaxePauschal.option_preis : 0,
            buffet: null,
            buffet_anzahl: 0,
            buffet_text: '',
            pauschal: true // Kennzeichnung für Template
          })
        }
        setTimeout(() => onArtikelgruppeSelected(), 0)
        console.log('Pauschal-Artikel hinzugefügt:', pauschalArtikel.id, 'für', anzahlPersonen, 'Personen')
      }
    }
  }
)

function findePauschalArtikelById(artikelId) {
  const gruppenartikel = getArtikelGruppenById(artikelId)
  for (const gruppe of gruppenartikel) {
    if (gruppe === 'Pauschal') {
      const artikel = pauschalArtikelGruppe.value.artikel.find(a => a.id === artikelId)
      if (artikel) {
        return artikel
      }
    }
  }
  return null
}


function findeUebernachtungsArtikelById(artikelId) {
  for (const gruppe of uebernachtungArtikelGruppen.value) {
    const artikel = gruppe.artikel.find(a => a.id === artikelId)
    if (artikel) {
      return artikel
    }
  }
  return null
}

// aktualisiert die Anzahl der bestellten Artikel basierend auf dem Datum
watch(
  () => [personalie.anreisetag, personalie.abreisetag, ...bestellung.value.map(b => b.artikel)],
  () => {
    const von = parseGermanDate(personalie.anreisetag)
    const bis = parseGermanDate(personalie.abreisetag)
    const event_von = parseGermanDate(aktuellesTreffen.value.zeitraum_von)
    const event_bis = parseGermanDate(aktuellesTreffen.value.zeitraum_bis)

    if (von && bis && !isNaN(von) && !isNaN(bis)) {
      const diff = Math.max(1, Math.ceil((bis - von) / (1000 * 60 * 60 * 24)))
      const event_diff = Math.max(1, Math.ceil((event_bis - event_von) / (1000 * 60 * 60 * 24)))
      let option_diff = 0
      if (diff > event_diff) {
        option_diff = diff - event_diff
      }
      // console.log(`Diff: ${diff}, Event-Diff: ${event_diff}, Option-Diff: ${option_diff}`)
      if (!aktuellesTreffen.value.verl_zimmer && option_diff > 0) {
        alert('Eine Verlängerung der Zimmerbuchung ist nicht möglich');
        option_diff = 0
        personalie.anreisetag = aktuellesTreffen.value.zeitraum_von
        personalie.abreisetag= aktuellesTreffen.value.zeitraum_bis
        return
      }

      bestellung.value.forEach(b => {
        if (b.artikel) {
          console.log(`Neu Artikel: ${b.artikel}, Anreisetag: ${personalie.anreisetag}, Abreisetag: ${personalie.abreisetag}, Diff: ${diff}`)
          // Finde den Artikel und prüfe Artikeldetail
          const gruppenartikel = getArtikelGruppenById(b.artikel)
          const PauschalArtikel = pauschalArtikelGruppe.value.artikel.find(a => a.id === b.artikel) 

          if (PauschalArtikel) {
            const KurtaxePauschal = PauschalArtikel.optionen?.find(o => o.option === 'P2')
            if (KurtaxePauschal) {
              console.log(`KurtaxePauschal P2 gefunden: ${KurtaxePauschal ? 'Ja' : 'Nein'}`)
              b.option_anzahl = diff 
            }
          }

          const uebernachtungsartikel = findeUebernachtungsArtikelById(b.artikel)
          const istUebernachtung = !!(
            uebernachtungsartikel &&
            gruppenartikel.some(g => ['Hotel', 'Camping'].includes(g))
          )
          if (istUebernachtung) {
            b.anzahl = istUebernachtung ? diff - option_diff : 1
            b.option_anzahl = istUebernachtung ? option_diff : 0
            if (b.option_anzahl > 0) {
              const verlängerungsOption = uebernachtungsartikel.optionen?.find(o => o.option === 'F1')
              if (verlängerungsOption) {
                b.option = verlängerungsOption
                b.option_text = verlängerungsOption.option_text
                b.option_preis = verlängerungsOption.option_preis
              }
            } else {
              b.option_anzahl = 0
              b.option_text = ''
              b.option_preis = 0
            }
            
            const buffetartikel = findeUebernachtungsArtikelById(b.artikel)
            if (buffetartikel) {
              // Einmal Buffet-Artikel prüfen
              buffet_artikel_b1 = buffetartikel.optionen?.find(o => o.option === 'B1')
              console.log(`Buffet-Artikel B1 gefunden: ${buffet_artikel_b1 ? 'Ja' : 'Nein'}`)
              if (buffet_artikel_b1) {
                b.buffet = buffet_artikel_b1 ? 'B1' : 'N'
                b.buffet_anzahl = buffet_artikel_b1?.option_anzahl ?? 1
                b.buffet_preis = buffet_artikel_b1?.option_preis ?? 0
                b.buffet_text = buffet_artikel_b1?.option_text ?? ''
              }
              // Pro Nacht Buffet-Artikel prüfen
              buffet_artikel_b2 = buffetartikel.optionen?.find(o => o.option === 'B2')
              console.log(`Buffet-Artikel B2 gefunden: ${buffet_artikel_b2 ? 'Ja' : 'Nein'}`)
              if (buffet_artikel_b2) {
                b.buffet = buffet_artikel_b2 ? 'B2' : 'N'
                b.buffet_anzahl = b.anzahl + b.option_anzahl ?? 1
                b.buffet_preis = buffet_artikel_b2?.option_preis ?? 0
                b.buffet_text = buffet_artikel_b2?.option_text ?? ''
              }
            }
          }        
          console.log(`Neu Artikel: ${b.artikel}, ArtikelGruppen: ${gruppenartikel.join(', ')}, Ist Übernachtung: ${istUebernachtung}, anzahl: ${b.anzahl}, option_anzahl: ${b.option_anzahl}`)
        }
      })
    }
  }
)

function validateGeburtsdatum(val, field) {
  if (val) {
    const trimmedVal = val.trim();
    
    // Aktualisiere das Feld mit dem getrimmten Wert
    if (field === 'personalie') personalie.geburtsdatum = trimmedVal;
    if (field === 'mitreisender') neuerMitreisender.geburtsdatum = trimmedVal;
    if (field === 'anreisetag') personalie.anreisetag = trimmedVal;
    if (field === 'abreisetag') personalie.abreisetag = trimmedVal;
    
    // Validierung mit dem getrimmten Wert
    if (!dateRegex.test(trimmedVal)) {
      alert('Bitte geben Sie das Geburtsdatum im Format TT.MM.JJJJ ein.');
      if (field === 'personalie') personalie.geburtsdatum = '';
      if (field === 'mitreisender') neuerMitreisender.geburtsdatum = '';
      if (field === 'anreisetag') personalie.anreisetag = '';
      if (field === 'abreisetag') personalie.abreisetag = '';
    }
  }
}

function sanitizeMitgliedsnummer(field) {
  if (field === 'personalie') {
    personalie.mitgliedsnummer = String(personalie.mitgliedsnummer || '').replace(/\D+/g, '')
  }
  if (field === 'mitreisender') {
    neuerMitreisender.mitgliedsnummer = String(neuerMitreisender.mitgliedsnummer || '').replace(/\D+/g, '')
  }
}

// aktualisiert die Optionen der Bestellung basierend auf den Artikel-IDs
watch(
  bestellung,
  (bestellArr) => {
    bestellArr.forEach(b => {
      if (b.artikel && b.option === null) {
        const artikel = alleArtikel.value.find(a => a.id === b.artikel)
        if (artikel && artikel.optionen?.length > 0) {
          b.option = artikel.optionen[0]
        }
      }
      // Automatische Anzahl für "pro Person" Artikel
      if (b.artikel) {
        const artikel = alleArtikel.value.find(a => a.id === b.artikel)
        if (artikel && artikel.artikeldetail && artikel.artikeldetail.toLowerCase().includes('pro person')) {
          const anzahlPersonen = 1 + mitreisende.value.filter(m => m.vorname || m.nachname).length
          b.anzahl = anzahlPersonen
        }
      }
    })
  },
  { deep: true }
)

// Watch auf mitreisende für "pro Person" Artikel 
watch(
  mitreisende,
  () => {
    bestellung.value.forEach(b => {
      if (b.artikel) {
        const artikel = alleArtikel.value.find(a => a.id === b.artikel)
        if (artikel && artikel.artikeldetail && artikel.artikeldetail.toLowerCase().includes('pro person')) {
          const anzahlPersonen = 1 + mitreisende.value.filter(m => m.vorname || m.nachname).length
          b.anzahl = anzahlPersonen
        }
      }
    })
  },
  { deep: true }
)

</script>

<template>
  <div v-if="anmeldung_geschlossen" class="alert alert-warning">
    <div class="header">
        <input type="hidden" :value="treffen" name="treffen" />
        <h3>
          <img :src="gwcdLogo" alt="GWCD Logo" class="logo" />
          <b>
          {{ aktTreffen.find(t => t.id == treffen)?.event }}
          ({{ formatDate(aktTreffen.find(t => t.id == treffen)?.zeitraum_von) }} - {{ formatDate(aktTreffen.find(t => t.id == treffen)?.zeitraum_bis) }})
          </b>
        </h3>
    </div>
    <br />
    {{ info_message }}
  </div>

  <form v-else-if="!buchungZusammenfassung" @submit.prevent="handleSubmit">
    <div class="header">
        <input type="hidden" :value="treffen" name="treffen" />
          <img :src="gwcdLogo" alt="GWCD Logo" class="logo" />
          <div class="header-text">
            <b>
            {{ aktTreffen.find(t => t.id == treffen)?.event }}
            ({{ formatDate(aktTreffen.find(t => t.id == treffen)?.zeitraum_von) }} - {{ formatDate(aktTreffen.find(t => t.id == treffen)?.zeitraum_bis) }})
            </b>
          </div>
    </div>
    <br />

    <div v-if="alleInfotexte.length > 0">
        <fieldset v-for="(info, idx) in alleInfotexte" :key="idx">
        <legend>{{ info.index }}</legend>
          <span v-html="info.text"></span>
        </fieldset>
    </div>

    <h2>Persönliche Daten</h2>
    <div class="form-group">
      <select class="form-control" v-model="personalie.gwcdmitglied" required>
        <option v-for="(label, value) in TYP_CHOICES" :key="value" :value="value">{{ label }}</option>
      </select>
    </div>
    <input
      v-if="personalie.gwcdmitglied === 'gwcd'"
      v-model="personalie.mitgliedsnummer"
      type="text"
      inputmode="numeric"
      pattern="[0-9]*"
      autocomplete="off"
      placeholder="Mitgliedsnummer *"
      required
      :disabled="!treffen"
      @input="sanitizeMitgliedsnummer('personalie')"
    />
    <input v-model="personalie.vorname" placeholder="Vorname *" required :disabled="!treffen" />
    <input v-model="personalie.nachname" placeholder="Nachname *" required :disabled="!treffen" />
    <input 
      v-model="personalie.geburtsdatum" 
      placeholder="Geburtsdatum *"
      required :disabled="!treffen" 
      @blur="validateGeburtsdatum(personalie.geburtsdatum, 'personalie')"
      />
    <input v-model="personalie.strasse" placeholder="Straße *" required :disabled="!treffen" />
    <input v-model="personalie.plz" placeholder="PLZ *" required :disabled="!treffen" />
    <input v-model="personalie.wohnort" placeholder="Ort *" required :disabled="!treffen" />
    <input v-model="personalie.telefon" placeholder="Telefon *" required :disabled="!treffen" />
    <input v-model="personalie.email" placeholder="E-Mail *" type="email" required :disabled="!treffen" />
    <textarea v-model="personalie.bemerkung" placeholder="Bemerkung"></textarea>

    <h2>Mitreisende</h2>
    <div v-if="mitreisende.length > 0">
      <ul style="margin-top:1em;margin-bottom: 2em;">
        <li v-for="(m, idx) in mitreisende" :key="idx" style="display:flex; align-items:center; gap:0.5em;">
          <span>
            {{ m.vorname }} {{ m.nachname }} 
            <span v-if="m.mitgliedsnummer">({{ m.mitgliedsnummer }})</span>
            <span v-if="m.geburtsdatum">, Geburtsdatum: {{ formatDate2(m.geburtsdatum) }}</span>
          </span>
          <button
            type="button"
            class="remove-btn"
            @click="removeMitreisender(idx)"
            title="Mitreisenden entfernen"
            style="margin-left:0.5em;"
            v-if="mitreisende.length > 1 && (m.vorname || m.nachname)"
          >🗑️</button>
        </li>
      </ul>
      <br />
    </div>
    <div class="form-group">
      <input
        v-model="neuerMitreisender.mitgliedsnummer"
        type="text"
        inputmode="numeric"
        pattern="[0-9]*"
        autocomplete="off"
        placeholder="Mitgliedsnummer oder leer"
        :disabled="!treffen"
        @input="sanitizeMitgliedsnummer('mitreisender')"
      />
      <input v-model="neuerMitreisender.vorname" placeholder="Vorname"  :disabled="!treffen" />
      <input v-model="neuerMitreisender.nachname" placeholder="Nachname"  :disabled="!treffen" />
      <input 
        v-model="neuerMitreisender.geburtsdatum" 
        placeholder="Geburtsdatum *" 
        :disabled="!treffen" 
        @blur="validateGeburtsdatum(neuerMitreisender.geburtsdatum, 'mitreisender')"
      />
      <button type="button" @click="addMitreisender" :disabled="!treffen">
        Mitreisenden hinzufügen
      </button>
    </div>    
    <br />
    <div style="display: flex; gap: 1em; align-items: center;">
      <span 
        v-for="g in alleArtikelGruppen.slice().filter(g => g.gruppe !== 'Pauschal').sort((a, b) => a.gruppe.localeCompare(b.gruppe))"
        :key="g.gruppe"
        style="display: flex; align-items: center;"
      >
        <label style="margin-right: 0.5em;">{{ g.gruppe }}</label>
        <input
          type="radio"
          :value="g.gruppe"
          v-model="ausgewaehlteArtikelgruppe"
          :disabled="!treffen"
          required
          name="artikelgruppe"
          style="margin-right: 1em;"
        />
      </span>
    </div>
    <!-- Neue Felder für Anreise und Abreise, nur wenn Hotel oder Camping gewählt ist -->
    <div
      v-if="ausgewaehlteArtikelgruppe === 'Alle' || ausgewaehlteArtikelgruppe === 'Hotel' || ausgewaehlteArtikelgruppe === 'Camping' || ausgewaehlteArtikelgruppe === 'Tagesgast'"
      style="display: flex; gap: 1em; align-items: center; margin-top: 1em;"
    >
      <label for="anreisetag">Anreisetag:</label>
      <input
        id="anreisetag"
        type="text"
        v-model="personalie.anreisetag"
        :disabled="!treffen"
        required
        @blur="validateGeburtsdatum(personalie.anreisetag, 'anreisetag')"
        style="max-width: 12em;"
      />
      <label for="abreisetag">Abreisetag:</label>
      <input
        id="abreisetag"
        type="text"
        v-model="personalie.abreisetag"
        :disabled="!treffen"
        required
        @blur="validateGeburtsdatum(personalie.abreisetag, 'abreisetag')"
        style="max-width: 12em;"
      />
    </div>
    <br />
    <table class="bestellung-tabelle">
      <thead>
        <tr>
          <th>Artikel</th>
          <th>Anzahl</th>
          <th>Artikelpreis</th>
          <th v-if="aktuellesTreffen && aktuellesTreffen.verl_zimmer">Optionanzahl</th>
          <th v-if="aktuellesTreffen && aktuellesTreffen.verl_zimmer">Optionpreis</th>
          <th v-if="aktuellesTreffen && aktuellesTreffen.buffet_pauschal">Buffet</th>
          <th v-if="aktuellesTreffen && aktuellesTreffen.buffet_pauschal">Buffet Anzahl</th>
          <th v-if="aktuellesTreffen && aktuellesTreffen.buffet_pauschal">Buffet Preis</th>
          <th>Summe €</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(b, idx) in bestellung" :key="idx">
          <td>
            <select 
                v-if="b.pauschal !== true"
                v-model="b.artikel" 
                required 
                :disabled="!treffen || !ausgewaehlteArtikelgruppe "
                >
              <option disabled value="">Bitte Artikel wählen *</option>
              <option v-for="a in gefilterteArtikel" :key="a.id" :value="a.id" :disabled="a.verfuegbar <= 0 || a.pauschal !== 'N' ">
                {{ a.artikelname }} {{ a.artikeldetail }} ({{ a.preis }})
              </option>
            </select>
            <span v-else>
              {{ alleArtikel.find(a => a.id === b.artikel)?.artikelname || 'Pauschal-Artikel' }} (Pauschal)
            </span>
          </td>
          <td>
            <span v-if="b.artikel && !istPauschalArtikel(b.artikel)">
              {{
                istUebernachtungsArtikel(b.artikel)
                  ? '1, ' + (b.anzahl || 1) +  (b.anzahl > 1 ? ' Nächte' : ' Nacht')
                  : (b.anzahl || 1)
              }}
            </span>
            <span v-if="b.artikel && istPauschalArtikel(b.artikel)">
              {{
                istPauschalArtikel(b.artikel)
                  ? (b.anzahl || 1) + (b.anzahl > 1 ? ' Personen' : ' Person')
                  : (b.anzahl || 1)
              }}
            </span>
          </td>
          <td>
            <span v-if="b.artikel">
              {{
                (alleArtikel.find(a => a.id === b.artikel)?.preis || 0)
              }}
            </span>
          </td>

          <td v-if="aktuellesTreffen && aktuellesTreffen.verl_zimmer">
            <span v-if="b.artikel && !istPauschalArtikel(b.artikel)">
              {{ b.option_anzahl > 0 ? ' + ' + b.option_anzahl + ' ' + (b.option_anzahl > 1 ? 'Nächte' : 'Nacht') : '' }}
            </span>
            <span v-if="b.artikel && istPauschalArtikel(b.artikel)">
              {{ b.option_anzahl > 0 ? + b.option_anzahl + ' ' + (b.option_anzahl > 1 ? 'Tage' : 'Tag') : '' }}
            </span>
          </td>

          <td v-if="aktuellesTreffen && aktuellesTreffen.verl_zimmer">
            <select
              v-if="b.artikel && b.option_anzahl > 0 && alleArtikel.find(a => a.id === b.artikel)?.optionen?.length"
              v-model="b.option"
              :disabled="!treffen || b.option_anzahl === 0"
            >
              <option disabled value="">Bitte Option wählen *</option>
              <option
                v-for="opt in alleArtikel.find(a => a.id === b.artikel).optionen.filter(o => o.option && o.option.startsWith('F') || o.option.startsWith('P'))"
                :key="opt.option"
                :value="opt"
              >
                {{ opt.option_text }} ({{ opt.option_preis }})
              </option>
            </select>          
          </td>
          
          <td v-if="aktuellesTreffen && aktuellesTreffen.buffet_pauschal">
            <span v-if="b.artikel"> 
              {{ b.buffet_text }}
            </span>
          </td>

          <td v-if="aktuellesTreffen && aktuellesTreffen.buffet_pauschal">
            <span v-if="b.artikel"> 
              {{ b.buffet_anzahl > 0 ? b.buffet_anzahl : '' }}
            </span>
          </td>

          <td v-if="aktuellesTreffen && aktuellesTreffen.buffet_pauschal">
            <span v-if="b.artikel"> 
              {{ b.buffet_anzahl > 0 ? b.buffet_preis : '' }}
            </span>
          </td>

          <td>
            <span v-if="b.artikel && !istPauschalArtikel(b.artikel)">
              {{
                (
                  ((alleArtikel.find(a => a.id === b.artikel)?.preis || 0) * (b.anzahl || 1)) +
                  (
                    alleArtikel.find(a => a.id === b.artikel)?.optionen?.find(opt => opt.option === b.option.option)?.option_preis || 0
                  ) * (b.option_anzahl || 0) +
                  ((b.buffet_preis || 0) * (b.buffet_anzahl || 0))
                ).toFixed(2)
              }}
            </span>          
            <span v-if="b.artikel && istPauschalArtikel(b.artikel)">
              {{
                (
                  ((b.anzahl || 1) *
                  (
                    alleArtikel.find(a => a.id === b.artikel)?.optionen?.find(opt => opt.option === b.option.option)?.option_preis || 0
                  ) * (b.option_anzahl || 0) )
                ).toFixed(2)
              }}
            </span>          
          </td>
          <td>
            <button
              type="button"
              @click="removeBestellung(idx)"
              v-if="bestellung.length > 1 && !b.pauschal && (b.artikel || b.anzahl)"
              class="remove-btn"
              title="Artikel löschen"
            >🗑️</button>
          </td>          
        </tr>
      </tbody>
    </table>

    <button 
      id="addBestellung" 
      type="button"
      @click="addBestellung" 
      :disabled="!treffen">
      weiteren Artikel hinzufügen
    </button>
    <!-- Summe anzeigen -->
    <div style="margin-top:1em; font-weight:bold;">
      Gesamt Summe: {{ bestellSumme.toFixed(2) }} €
    </div>    


    <h2>Zur Kenntnisnahme und Bestätigung</h2>
    <div v-for="rt in alleRechtstexte" :key="rt.id">
      <label>
        <input type="checkbox" class="big-checkbox" :value="rt.id" v-model="rechtstexte" />
        <span class="rechtstext-label" v-html="rt.text"></span>
      </label>
    </div>
    <button type="submit" :disabled="isSubmitting || !alleRechtstexteBestaetigt">Anmelden und Buchen</button>
    <br />
  </form>

  <div v-else class="zusammenfassung">
    <!-- Django Template Buchungszusammenfassung (Priorität) -->
    <div v-if="buchungHtml" v-html="buchungHtml"></div>
    
    <!-- Fallback: Vue Buchungszusammenfassung -->
    <div v-else-if="buchungZusammenfassung">
      <h2 style="font-weight:bold;">Buchungszusammenfassung</h2>

    <div style="margin-left:2em; padding:0.5em 1em; border-left:3px solid #ccc; background:#f9f9f9;">
      <table  cellspacing="2" cellpading="4">
        <tbody>
          <tr>
          <td>Treffen:</td> <td>{{ buchungZusammenfassung.treffen.event }} ({{ formatDate(buchungZusammenfassung.treffen.zeitraum_von) }} - {{ formatDate(buchungZusammenfassung.treffen.zeitraum_bis) }})</td>
          </tr>
          <tr>
          <td>Mitgliedsnummer:</td> <td>{{ buchungZusammenfassung.personalie.mitgliedsnummer }}</td>
          </tr>
          <tr>
          <td>Name:</td> <td>{{ buchungZusammenfassung.personalie.vorname }} {{ buchungZusammenfassung.personalie.nachname }}</td>
          </tr>
          <tr>
          <td>Geburtsdatum:</td> <td>{{ formatDate(buchungZusammenfassung.personalie.geburtsdatum) }}</td >
          </tr>
          <tr>
          <td>Adresse:</td> <td>{{ buchungZusammenfassung.personalie.strasse }}</td>
          </tr>
          <tr>
          <td>Wohnort:</td> <td>{{ buchungZusammenfassung.personalie.plz }} {{ buchungZusammenfassung.personalie.wohnort }}</td>
          </tr>
          <tr>
          <td>Telefon:</td> <td>{{ buchungZusammenfassung.personalie.telefon }}</td>
          </tr>
          <tr>
          <td>E-Mail:</td> <td>{{ buchungZusammenfassung.personalie.email }}</td>
          </tr>
        </tbody>
      </table>
      <p>{{ buchungZusammenfassung.personalie.bemerkung || "  Keine Bemerkung" }}</p>
    </div>    

    <div v-if="buchungZusammenfassung.mitreisende.length" style="margin-left:2em; padding:0.5em 1em; border-left:3px solid #ccc; background:#f9f9f9;">
      <strong>Mitreisende:</strong>
      <ul>
        <li v-for="(m, idx) in buchungZusammenfassung.mitreisende" :key="idx">
          {{ m.vorname }} {{ m.nachname }} , Geb.datum: {{ formatDate(m.geburtsdatum) }} ({{ m.mitgliedsnummer }})
        </li>
      </ul>
    </div>

    <div style="margin-left:2em; padding:0.5em 1em; border-left:3px solid #ccc; background:#f9f9f9;">
      <strong>Bestellungen :</strong>
      <p>Reservierungsanfrage für den Zeitraum vom {{ buchungZusammenfassung.personalie.anreisetag }} bis {{ buchungZusammenfassung.personalie.abreisetag }}</p>
      <table style="border-collapse:collapse; margin-left:2em; background:#f9f9f9;">
        <thead>
          <tr>
            <th style="border:1px solid #ccc; padding:0.3em 0.7em;">Artikel</th>
            <th style="border:1px solid #ccc; padding:0.3em 0.7em;">Option</th>
            <th style="border:1px solid #ccc; padding:0.3em 0.7em;">Einzelpreis</th>
            <th style="border:1px solid #ccc; padding:0.3em 0.7em;">Anzahl</th>
            <th style="border:1px solid #ccc; padding:0.3em 0.7em;">Gesamt</th>
          </tr>
        </thead>
        <tbody v-for="(b, idx) in buchungZusammenfassung.bestellung" :key="idx">
          <tr v-if="b.artikelId">
            <td style="border:1px solid #ccc; padding:0.3em 0.7em;">{{ b.artikelname }} ({{ b.artikeldetail }})</td>
            <td style="border:1px solid #ccc; padding:0.3em 0.7em;"></td>
            <td style="border:1px solid #ccc; padding:0.3em 0.7em; text-align: right;">{{ b.preis }}</td>
            <td style="border:1px solid #ccc; padding:0.3em 0.7em;">
              {{
                  istUebernachtungsArtikel(b.artikelId)
                    ? '1, ' + (b.anzahl || 1) +  (b.anzahl > 1 ? ' Nächte' : ' Nacht')
                  : (b.anzahl || 1) + ' Stück, '
              }}
            </td>
            <td style="border:1px solid #ccc; padding:0.3em 0.7em; text-align: right;">
              {{
                  (b.anzahl * parseFloat(b.preis)).toFixed(2)
              }} 
            </td>
          </tr>
          <template v-if="b.option_array && b.option_array.length">
            <tr v-for="(opt, oidx) in b.option_array" :key="oidx">
              <td style="border:1px solid #ccc; padding:0.3em 0.7em;"></td>

              <td style="border:1px solid #ccc; padding:0.3em 0.7em;" v-if="opt.value.startsWith('F')">{{ opt.text }} </td>                  
              <td style="border:1px solid #ccc; padding:0.3em 0.7em; text-align: right;" v-if="opt.value.startsWith('F')">{{ opt.preis }}</td>
              <td style="border:1px solid #ccc; padding:0.3em 0.7em;" v-if="opt.value.startsWith('F')">{{ opt.anzahl > 0 ? ' + ' + opt.anzahl + ' ' + (opt.anzahl > 1 ? 'Nächte' : 'Nacht') : '' }}</td>
              <td style="border:1px solid #ccc; padding:0.3em 0.7em; text-align: right;" v-if="opt.value.startsWith('F')">
                {{
                    (opt.anzahl * parseFloat(opt.preis)).toFixed(2)
                }} 
              </td>

              <td style="border:1px solid #ccc; padding:0.3em 0.7em;" v-if="opt.value.startsWith('B1')">{{ opt.text }}</td>
              <td style="border:1px solid #ccc; padding:0.3em 0.7em; text-align: right;" v-if="opt.value.startsWith('B1')">{{ opt.preis }}</td>
              <td style="border:1px solid #ccc; padding:0.3em 0.7em;" v-if="opt.value.startsWith('B1')"></td>
              <td style="border:1px solid #ccc; padding:0.3em 0.7em; text-align: right;" v-if="opt.value.startsWith('B1')">
                {{
                    (parseFloat(opt.preis)).toFixed(2)
                }} 
              </td>
              
              <td style="border:1px solid #ccc; padding:0.3em 0.7em;" v-if="opt.value.startsWith('B2')">{{ opt.text }} </td>
              <td style="border:1px solid #ccc; padding:0.3em 0.7em; text-align: right;" v-if="opt.value.startsWith('B2')">{{ opt.preis }}</td>
              <td style="border:1px solid #ccc; padding:0.3em 0.7em;" v-if="opt.value.startsWith('B2')">{{ opt.anzahl > 0 ? ' + ' + opt.anzahl + ' ' + (opt.anzahl > 1 ? 'Nächte' : 'Nacht') : '' }}</td>
              <td style="border:1px solid #ccc; padding:0.3em 0.7em; text-align: right;" v-if="opt.value.startsWith('B2')">
                {{
                    (opt.anzahl * parseFloat(opt.preis)).toFixed(2)
                }} 
              </td>

              <td style="border:1px solid #ccc; padding:0.3em 0.7em;" v-if="opt.value.startsWith('P2')">{{ opt.text }} </td>
              <td style="border:1px solid #ccc; padding:0.3em 0.7em; text-align: right;" v-if="opt.value.startsWith('P2')">{{ opt.preis }}</td>
              <td style="border:1px solid #ccc; padding:0.3em 0.7em;" v-if="opt.value.startsWith('P2')">{{ opt.anzahl > 0 ? ' + ' + opt.anzahl + ' ' + (opt.anzahl > 1 ? 'Tage' : 'Tag') : '' }}</td>
              <td style="border:1px solid #ccc; padding:0.3em 0.7em; text-align: right;" v-if="opt.value.startsWith('P2')">
                {{
                    (opt.anzahl * parseFloat(opt.preis)).toFixed(2)
                }} 
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <div style="font-weight:bold;">
        Gesamtsumme: {{
          buchungZusammenfassung.bestellung.reduce((sum, b) =>
            sum +
            (b.anzahl * parseFloat(b.preis)) +
            b.option_array.reduce((osum, opt) => osum + (parseFloat(opt.preis) * (opt.anzahl || 0)), 0)
          , 0).toFixed(2)
        }} €
      </div>
    </div>
    <div>
      <strong>Kenntnissnahme und Bestätigung:</strong>
      <ul>
        <li v-for="rt in buchungZusammenfassung.rechtstexte" :key="rt.id">
          <span v-html="rt.text"></span>
        </li>
      </ul>
    </div>
    <br />
    <strong>Eine Email zur Bestätigung wird an die angegebene Mailadresse gesendet.</strong>
    <br />
    </div> <!-- Ende Vue Fallback Zusammenfassung -->
  </div>
</template>

<style scoped>
body {
  font-family: Arial, sans-serif;
  background: #f5f5f5;
  color: #333;
  font-size: 12px;
}
.header {
  display: flex;
  align-items: center;
  gap: 1.5em;
}

.header-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 1.1em;
  color: #222 !important;   /* oder #000 für echtes Schwarz */
  background: transparent !important;
  -webkit-text-fill-color: #222 !important; /* für Safari/Firefox */
}

form, .zusammenfassung {
  max-width: 100vw;
  margin: 0 auto;
  padding: 1em;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

h2 {
  font-size: 1.1em;
  margin-top: 1em;
}

input, select, textarea, button {
  width: 100%;
  font-size: 1em;
  padding: 0.7em;
  border-radius: 4px;
  border: 1px solid #ccc;
  box-sizing: border-box;
}

.logo {
  height: 75px;
  width: 66px;
}
span b, span strong {
  font-weight: bold !important;
}

button {
  width: auto;
  padding: 0.7em 1.5em;
  background: #1976d2;
  color: #fff;
  border: none;
  margin-top: 0.5em;
  border-radius: 4px;
  font-weight: bold;
}

button[disabled] {
  background: #aaa;
}

div[role="group"], .bestellung-row, .mitreisende-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5em;
}

label {
  display: flex;
  align-items: flex-start;
  gap: 0.5em;
  margin-bottom: 0.5em;
}
.rechtstext-label {
  line-height: 1.3;
}
.big-checkbox[type="checkbox"] {
  width: 1rem;
  height: 1rem;
  margin-top: 0.1rem;
  accent-color: #007bff; /* Optional: Bootstrap-Blau */
  display: block;
}
b, strong {
  font-weight: bold !important;
}


.remove-btn {
  background: none;
  border: none;
  color: #b71c1c;
  font-size: 1.3em;
  padding: 0 0.5em;
  cursor: pointer;
  margin-left: 0.5em;
  line-height: 1;
  transition: color 0.2s;
}
.remove-btn:hover {
  color: #f44336;
}

.rechtstext-label,
fieldset,
fieldset legend,
span[v-html] {
  font-size: 1em;
  color: #222 !important;   /* oder #000 für echtes Schwarz */
  background: transparent !important;
  -webkit-text-fill-color: #222 !important; /* für Safari/Firefox */
}

.alert {
  padding: 1em;
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  color: #856404;
  border-radius: 4px;
  margin-bottom: 1em;
}

.bestellung-tabelle {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1em;
}

.bestellung-tabelle th, .bestellung-tabelle td {
  border: 1px solid #ccc;
  padding: 0.5em;
  text-align: left;
  font-size: 0.9em;
}

.bestellung-tabelle th {
  background: #f5f5f5;
  font-weight: bold;
}

.bestellung-tabelle tr:nth-child(even) {
  background: #fafafa;
}
/* Handy: bis 600px */
@media (max-width: 600px) {
  .rechtstext-label,
  span[v-html] {
    font-size: 1em;
  }
  form, .zusammenfassung {
    padding: 0.5em;
    max-width: 98vw;
    border-radius: 2px;
  }
  input, select, textarea, button {
    font-size: 0.95em;
    padding: 0.5em;
  }
  h2 {
    font-size: 1em;
  }
  .header-text {
    font-size: 1.3em;
  }
}

/* Tablet: 601px bis 1023px */
@media (min-width: 601px) and (max-width: 1023px) {
  .rechtstext-label,
  span[v-html] {
    font-size: 1.05em;
  }
  form, .zusammenfassung {
    max-width: 90vw;
    padding: 1.2em;
    border-radius: 6px;
  }
  input, select, textarea, button {
    font-size: 1em;
    padding: 0.7em;
  }
  h2 {
    font-size: 1.15em;
  }
  .header-text {
    font-size: 1.35em;
  }
}

/* PC: ab 1024px */
@media (min-width: 1024px) {
  .rechtstext-label,
  span[v-html] {
    font-size: 1.1em;
  }
  form, .zusammenfassung {
    max-width: 900px;
    padding: 2em;
    border-radius: 8px;
  }
  input, select, textarea, button {
    font-size: 1.1em;
    padding: 1em;
  }
  h2 {
    font-size: 1.2em;
  }
  .header-text {
    font-size: 1.4em;
  }
}

</style>